import { AiCreditPack } from '../../services/ai-credits-purchase-contract';

/**
 * Which pack is selected when the Buy credits dialog opens. Never nothing when there
 * is anything to choose — an empty selection would leave the primary button disabled
 * on a dialog the user opened in order to buy.
 *
 * Kept out of the dialog module so it is unit-testable without Angular.
 */
export function pickDefaultPack(packs: AiCreditPack[] | null | undefined): AiCreditPack | null {
    if (!packs || !packs.length) return null;
    return packs.filter(pack => pack.featured)[0] || packs[0];
}
